import { INPUT_TYPE } from "../constants/Constant";
import TableDataParser from "../Helper/TableDataParser";
import { IColumn, IFilterCondition, ITableFilter } from "../model/Table";
export const TABLES = {
  CONTACT: "contact",
  CANDIDATE: 'candidate',
  DEAL: "deal",
  SEGMENT: "segment",
  JOBOPENING: "jobopening",
  CAMPAIGN: "campaign",
  FORM: "form",
  LANDING_PAGE: "landing_page",
  PIPELINE: "pipeline",
  STAGE: "stage",
  ACTIVITY: "activity",
  AUTOMATION: "automation",
  FUNNEL: "funnel",
  JOB_PIPELINE: "jobpipeline",
  JOB_STAGE: "jobstage",
  JOB_FORMS: "jobform",
  PAYROLL: "people_payroll",
  ATTENDANCE: "people_attendance",
  TEAM_ATTENDANCE: "people_attendance_team_report",
  PAYROLL_PROCESS: "people_process_payroll",
  ADD_PAYROLL: "people_add_payroll",
  PAYMENT_SUMMARY: "payment_summary",
  EMPLOYEE_LIST: "people_employee_list",
  PEOPLE_COMPONENT: "people_component",
  PAY_SCHEDULE: "people_pay_schedule",
  PAYSTUB_LIST: "people_paystub_list",
  ADD_PAY_SCHEDULE: "people_add_pay_schedule",
  PEOPLE_EMPLOYEE_TAX_DECLARATION: "people_employee_tax_declaration",
  EMPLOYEE_TERMINATION: "employee_termination",
  CUSTOME_FIELD_LIST: "people_custom_field",
  COMPONENT_GROUP_LIST: "people_component_groups",
  PAYROLL_SUMMARY: "people_payroll_summary",
  BENEFIT_LIST: "people_benefit_list",
  PAYROLL_LIABILITY_REPORT: "people_payroll_liability_report",
  CONTRACTOR_LIST: "people_contractor_list",
  EMPLOYEE: "employee",
  CONTRACTOR_PAYROLL: "people_contractor_payroll",
  SYNC_JE_TO_BOOKS: "sync_je_to_books",
  IMPORT_LOG:"people_import_log",
  PEOPLE_DOCUMENT: "people_document",
  PEOPLE_EXPENSE_CLAIMS: "people_expense_claims",
  PEOPLE_EXPENSE_GROUP: "people_expense_group",
  PEOPLE_EXPENSE_CATEGORY: "people_expense_category",
  PEOPLE_AUTOMATION: "people_automation",
  PEOPLE_EXPENSE_SYNC_REVERT: "people_expense_sync_revert_je",
  PEOPLE_EXPENSE_GROUP_USER: "people_expense_group_user",
  PEOPLE_EXPENSE_PENDING_CLAIMS: "people_expense_pending_claims",
  PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_GROUP: "people_expense_claims_breakdown_group",
  PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_CATEGORY: "people_expense_claims_breakdown_category",
  PEOPLE_EXPENSE_MY_CLAIMS: "people_expense_my_claims",
  PEOPLE_EXPENSE_APPROVED_CLAIMS: "people_expense_approved_claims",
  PEOPLE_MULTIPLE_EXPENSE: "people_multi_expense",
  PEOPLE_LOCATION_LIST: 'people_location_list',
  PEOPLE_PROFSESSION_TAX_REPORT:'people_profession-tax-report',
  PEOPLE_EPF_TAX_REPORT: "people_epf_tax_report",
  PEOPLE_ESI_TAX_REPORT: "people_esi_tax_report",
  PEOPLE_ATTENDANCE_SETTING: "people_attendance_setting",
  PEOPLE_LOCATION_EMPLOYEE_MAPPING:"people_location_employee_mapping",
  PEOPLE_ASSESSMENT_REVIEW: "people_assessment_review",
  PEOPLE_GIRO: "people_giro",
  PEOPLE_GIRO_EMPLOYEE: "people_giro_employee",
  PEOPLE_PAYMENT_LOGS: "people_payment_logs",
  PEOPLE_IRAS_SUMMARY_REORT: "people_iras_summary_report",
  PEOPLE_IRAS_AIS_SUBMISSION: "people_iras_ais_submission",
  PEOPLE_IRAS_AIS_SUBMISSION_LOGS: "people_iras_ais_submission_logs",
  PEOPLE_SHIFTS: "people_shifts",
  PEOPLE_SHIFT_MEMBERS: "people_shift_members",
  PEOPLE_ASSIGN_MEMBERS: "people_assign_members",
  PEOPLE_IR8S: "people_ir8s",
  PEOPLE_COMPONENT_FORMULA: "people_component_formula",
  PEOPLE_OVERTIME_LIST: "people_overtime_list",
  PEOPLE_OVERTIME_RATE_CONFIG: "people_overtime_rate_config",
  PEOPLE_MANAGE_COMP_OFF: "people_manage_comp_off",
  PEOPLE_MANAGE_COMP_OFF_REQUESTS: "people_manage_comp_off_request",
  PEOPLE_APPLY_COMP_OFF_REQUEST : "people_apply_comp_off_request",
  PEOPLE_EMAIL_TEMPLATE: "people_email_template",
  PEOPLE_BASIC_EMAIL_TEMPLATE: "people_basic_email_template",
  PEOPLE_DASHBAORD_TEAM_ATTENDANCE: "people_dashboard_attendance_team",
  PEOPLE_AUDIT_LOGS: "people_audit_logs",
  PEOPLE_TIMESHEET_REPORT: "people_timesheet_report",
  PEOPLE_TIMESHEET_REPORT_GROUP: "people_timesheet_report_group",
  PEOPLE_FORM16: "people_form16",
  PEOPLE_SALARY_HISTORY: "people_salary_history",
  PEOPLE_PERFORMANCE_GOAL: "people_performance_goal",
  PEOPLE_APPRAISAL_CYCLES: 'people_appraisal_cycles',
  PEOPLE_EXPENSE_LIMIT: 'people_expense_limit',
  PEOPLE_PROJECT: 'people_project',
  PEOPLE_TASK: "people_task",
  PEOPLE_TIMESHEET_ENTRY: "people_timesheet_entry",
  PEOPLE_COMMISSION_REPORT: "people_commission_report",
  PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE: "people_timesheet_report_group_sub_table",
  POLICY_AND_RESOURCES: "policy_and_resources"
};
export const PRODUCTS = {
  PAYROLL: "Payroll",
  ELEAVE: "eLeave",
  EXPENSE: "Expense",
  EXPENSE_TREND: "Expense_Trend"
}
export const COLUMN_CODE = {
  CONTACT: {
    NAME: `name`,
    EMAIL: `email`,
    TYPE: `type`,
    PHONE: `phone`,
    ORGANISATION: `organisation`,
    ADDRESS: `address`,
    SEGMENT: `segment`,
    STATUS: `status`,
    LABEL: `label`,
    PROFILE_PIC: `profile_pic`,
  },
  CANDIDATE: {
      NAME: 'name',
      EMAIL: 'email',
      PHONE: 'phone',
      ADDRESS: 'address',
      JOBOPENING: 'job_opening',
      STATUS: 'status',
      JOB_PIPELINE_ID: 'job_pipeline_id',
      JOB_STAGE_ID: 'job_stage_id',
      TYPE: `type`,
      LABEL: `label`,
      PROFILE_PIC: `profile_pic`,
      DOCUMENT: 'document',
      NOTE: 'note',
      EMPLOYEE_ID: 'employeeId',
      USER_ID: 'userId'

  },
  CAMPAIGN: {
    NAME: `name`,
    TYPE: `type`,
    PUBLISHED_ON: `published_on`,
    DELIVERED: `delivered`,
    OPEN: `open`,
    CLICKS: `clicks`,
    STATUS: `status`,
    HTML_DATA: `html_data`,
    JSON_DATA: `json_data`,
    THUMBNAIL: `thumbnail`,
    PUBLISHED: `published`,
    CAMPAIGN_TYPE: `campaign_type`,
    DIRECT_LINK: `direct_link`,
    SEGMENT_ID: `segment_id`,
    EMAIL_SUBJECT: `email_subject`,
    EMAIL_FROM: `email_from`,
    EMAIL_PRE_HEADER: `email_preheader`,
    HASH: `hash`,
    SEND_NOW: `send_now`,
    SMTP_SETUP_ID: `smtp_setup_id`,
  },
  FORMS: {
    NAME: `name`,
    EMBED_URL: `embed_url`,
    DOMAIN: `domain`,
    VISITORS: `visitors`,
    CLICKS: `clicks`,
    STATUS: `status`,
    HTML_DATA: `html_data`,
    JSON_DATA: `json_data`,
    THUMBNAIL: `thumbnail`,
    DIRECT_LINK: `direct_link`,
    SEGMENT_ID: `segment_id`,
    PUBLISHED: `published`,
    HASH: `hash`,
    CUSTOM_DOMAIN: "custom_domain",
  },
  LANDING_PAGE: {
    NAME: `name`,
    DOMAIN: `domain`,
    VISITORS: `visitors`,
    STATUS: `status`,
    HTML_DATA: `html_data`,
    JSON_DATA: `json_data`,
    THUMBNAIL: `thumbnail`,
    DIRECT_LINK: `direct_link`,
    PUBLISHED: `published`,
    SEGMENT_ID: `segment_id`,
    HASH: `hash`,
    CUSTOM_DOMAIN: `custom_domain`,
  },
  PIPELINE: {
    NAME: `name`,
    STAGE_ID_S: `stage_id_s`,
    IS_DEFAULT: `is_default`,
  },
  STAGES: {
    NAME: `name`,
    ORDER: `order`,
    WON_STAGE: `won_stage`,
    LOST_STAGE: `lost_stage`,
    HELP_TEXT: `help_text`,
  },
  DEAL: {
    NAME: `name`,
    CLOSING_DATE: `closing_date`,
    STAGE_ID: `stage_id`,
    PIPELINE_ID: `pipeline_id`,
    AMOUNT: `amount`,
    CONTACT_ID: `contact_id`,
    DEAL_DATE: `deal_date`,
    OWNER_ID: `owner_id`,
    VISIBILITY: `visibility`,
    ORGANIZATION_ID: `organization_id`,
    STATUS: `status`,
    REASON: `reason`,
    NOTE: `note`,
  },
  ACTIVITY: {
    NAME: `name`,
    ACTIVTY_TYPE: `activity_type`,
    START_DATE: `start_date`,
    END_DATE: `end_date`,
    NOTES: `notes`,
    ASSIGNEE_IDS: `assignee_ids`,
    CONTACT_IDS: `contact_ids`,
    ORGANIZATION_IDS: `organization_ids`,
    LINKED_TO: `linked_to`,
    STATUS: `status`,
    SEND_INVITATION: `send_invitation`,
    SEND_CONTACTS_INVITATION: `send_contacts_invitation`,
  },
  FUNNEL: {
    NAME: `name`,
    DOMAIN: `domain`,
    VISITORS: `visitors`,
    LEADS: `leads`,
    CLICKS: `clicks`,
    STATUS: `status`,
    HTML_DATA: `html_data`,
    JSON_DATA: `json_data`,
    THUMBNAIL: `thumbnail`,
    DIRECT_LINK: `direct_link`,
    PUBLISHED: `published`,
    SEGMENT_ID: `segment_id`,
    HASH: `hash`,
    CUSTOM_DOMAIN: "custom_domain",
  },
  JOB_PIPELINE: {
    NAME: `name`,
    STAGE_ID_S: `stage_id_s`,
    IS_DEFAULT: `is_default`,
  },
  JOB_STAGE: {
    NAME: `name`,
    ORDER: `order`,
    WON_STAGE: `won_stage`,
    LOST_STAGE: `lost_stage`,
    HELP_TEXT: `help_text`
  },
  JOB_FORMS: {
    NAME: `name`,
    EMBED_URL: `embed_url`,
    DOMAIN: `domain`,
    VISITORS: `visitors`,
    CLICKS: `clicks`,
    STATUS: `status`,
    HTML_DATA: `html_data`,
    JSON_DATA: `json_data`,
    THUMBNAIL: `thumbnail`,
    DIRECT_LINK: `direct_link`,
    SEGMENT_ID: `jobopening_id`,
    PUBLISHED: `published`,
    HASH: `hash`,
    CUSTOM_DOMAIN: "custom_domain",
    JOB_PIPELINE_ID:"job_pipeline_id"
  },
  PAYROLL: {
    PAYDATE: `payDate`,
    WORK_PERIOD: `workPeriod`,
    TOTAL_EARNINGS: `totalEarnings`,
    EMPLOYER_COST: `employerCost`,
    TOTAL_COST: `totalCost`,
    STATUS: `status`,
    ID: `id`,
    EMPLOYEES: `employeeDetails`,
    PAYMENT_STATUS: `paymentStatus`
  },

  PAYSTUB: {
    DATE: `date`,
    DAYS: `days`,
    PERIOD: `period`,
    VENDOR: `vendor`,
    GROSS_PAY: `grossPay`,
    TAXES: `taxes`,
    NET_PAY: `netPay`,
    AMOUNT_PAID: `amountPaid`,
    FILE_PATH: `filePath`,
    ID: `id`
  },

  ATTENDANCE:{
    DATE: 'date',
    SHIFT: 'shift',
    CLOCK_IN : 'clockIn',
    CLOCK_OUT: 'clockOut',
    TOTAL_MINUTES: 'totalMinutes',
    TOTAL_MINUTES_BY_PUNCH_LOGS: 'totalMinutesByPunchLogs',
    ENTRY: 'entryOffsetMinutes',
    EXIT: 'exitOffsetMinutes',
    ID: `id`
  },
  ATTENDANCE_DRILL_DOWN:{
    PUNCH_DATE: 'date',
    PUNCH_TIME : 'time',
    TYPE: 'type',
    CLOCK_IN: 'clockIn',
    REMARK: 'remark'
  },
  ATTENDANCE_TEAM:{
    EMPLOYEE_NAME:'employeeName',
    SHIFT: 'shift',
    EMPLOYEE_ID:'employeeId',
    DESIGNATION:'designation',
    CLOCK_IN : 'clockIn',
    CLOCK_OUT: 'clockOut',
    TOTAL_MINUTES: 'totalMinutes',
    TOTAL_MINUTES_BY_PUNCH_LOGS: 'totalMinutesByPunchLogs',
    ENTRY: 'entryOffsetMinutes',
    EXIT: 'exitOffsetMinutes'
  },
  DASHBAORD_TEAM_ATTENDANCE: {
    EMPLOYEE_NAME:'employeeName',
    STATUS: 'status',
    CLOCK_IN : 'clockIn',
    CLOCK_OUT: 'clockOut'
  },
  PEOPLE_TIMESHEET_REPORT: {
    STATUS: 'status',
    CUSTOMER: "customer",
    PROJECT: "projectId",
    TASK: "jobId",
    DATE: "date",
    FROM_DATE: "fromDate",
    TO_DATE: "toDate",
    EMPLOYEE: "employee",
    BILLABLE: "billable",
    HOURS: "hours",
    RATE_PER_HOUR: "ratePerHour",
    AMOUNT: "amount",
    INVOICE_STATUS: "invoiceStatus",
    INTERNAL_INVOICE_NUMBER: "internalInvoiceNumber"
  },
  ADD_PAYROLL: {
    PAYRUN_TYPE: `payrunType`,
    PAY_SCHEDULE: `paySchedule`,
    PAY_PERIOD: `payPeriod`,
    WORK_WEEKS: `workWeek`,
    PAY_DAY: `payDay`,
    PAY_DATE: `payDate`,
    WORK_PERIOD_FROM: `workPeriodFrom`,
    WORK_PERIOD_To: `workPeriodTo`,
    LOCATION: "locations",
    APPLICABLE_TO_ALL: `isForAllUsers`,
    USERS: `employees`
  },
  PROCESS_PAYROLL: {
    EMPLOYEE: `employee`,
    OVERTIME: `overtime`,
    LOP: `lop`,
    ADDITIONAL_EARNING: `additionalEarning`,
    DEDUCTION: `deduction`,
    EMPLOYER_CONTRIBUTION: `employerContribution`,
    NET_PAY: `netPay`,
    PAYRUN_ID: `payrunId`,
    EMPLOYEE_NAME: `employeeName`,
    EMPLOYEE_ID: 'empId'
  },

  PAY_SCHEDULE_LIST: {
    PAY_SCHEDULE : `paySchedule`,
    PAY_PERIOD: `payPeriod`,
    DAY_OF_WEEK: `dayOfWeek`,
    DAY_OF_MONTH: `dayOfMonth`,
    DEADLINE_FOR_PAYRUN: `deadlineForPayrun`,
    WORK_WEEK: `workWeek`,
    PAY_DAY:`payDay`,
    PAY_DATE: `payDate`,
    WORK_PERIOD_FROM: `workPeriodFrom`,
    WORK_PERIOD_TO: `workPeriodTo`,
    IS_APPLICABLE_TO_ALL: `isForAllUsers`,
    EMPLOYEES: `employees`,
    ID: `id`,
    LOCATION: "locations",
    APPLICABLE_TO_USERS: `applicableToUsers`
  },

  CUSTOM_FIELD_LIST: {
    NAME : `name`,
    TYPE : `type`,
    MAX_LENGTH : `fieldMaxLength`,
    DISPLAY_IN : `displayIn`,
    STATUS: 'status',
    ID : `id`
  },

  PROFESSIONAL_TAX_REPORT: {
    EMPLOYEE_ID: `employeeId`,
    EMPLOYEE_NAME: `employeeName`,
    PT_WAGES: `ptWages`,
    PT_AMOUUNT: `ptAmount`,
    PT_TAX:"professionalTax",
    ID : `id`
  },

  COMPONENT_GROUP_LIST: {
    NAME : `name`,
    ID : `id`,
  },

  BENEFITS_LIST : {
    NAME : "name",
    EMPLOYEE_DEDUCTION : "employeeDeduction",
    EMPLOYER_DEDUCTION : "employerDeduction",
    ANUAL_MAXIMUM_CONTRIBUTION : "annualMaximumContribution",
    TYPE : "type",
    STATUS : "status",
    ID : `id`,
  },

  PEOPLE_EMPLOYEE_LIST: {
      EMPLOYEE_NAME: "name",
      COMPENSATION: "compensation",
      DESIGNATION: "designation",
      EMPLOYEE_ID: "employeeId",
      CTC: "ctc",
      FIRST_PAY_DATE: "firstPayDate",
      STATUS: "status",
      USER_ID: `userId`,
      ROLES: `roles`
  },
  PEOPLE_COMPONENT:{
      COMPONENT_NAME: "name",
      TYPE: "status",
      AMOUNT_TYPE: "isVariable",
      EPF:"pf",
      ESI:"esi",
      TAX_EXEMPT: "taxexempt",
      STATUS: "isActive",
      DEDUCTION_TYPE: 'deductionType'
  },
  PEOPLE_EMP_TAX_DECLARATION :{
    EMPLOYEE_NAME: "employeeName",
    SUBMITTED_ON: "submitOn",
    STATUS: "status"
  },
  PAYROLL_SUMMARY: {
    EMPLOYEE: `employee`,
    OVERTIME: `overtime`,
    LOP: `lop`,
    ADDITIONAL_EARNING: `additionalEarning`,
    DEDUCTION: `deduction`,
    EMPLOYER_CONTRIBUTION: `employerContribution`,
    NET_PAY: `netPay`,
    PAYRUN_ID: `payrunId`,
    EMPLOYEE_NAME: `employeeName`,
    PAYMENT_STATUS: `paymentStatus`
  },
  PAYROLL_LIABILITY_REPORT: {
    DISPLAY_NAME: 'displayName',
    EMPOLYEE_CONTRIBUTION: 'employeesContribution',
    EMPLOYER_CONTRIBUTION: `employerContribution`,
    NAME: 'name',
    TOTAL: 'total'
  },
  PEOPLE_CONTRACTOR_LIST: {
    EMPLOYEE_NAME: `name`,
    TYPE: `type`,
    EMAIL_ID: `emailId`,
    UNIQUE_ID: `uniqueId`,
    STATUS: "status",
    USER_ID: `userId`,
    ROLES: `roles`
  },
  CONTRACTOR_PAYROLL: {
    PAYDATE: `payDate`,
    TOTAL_COST: `totalCost`,
    STATUS: `status`,
    ID: `id`,
  },
  CONTRACTOR_PROCESS_PAYROLL: {
    CONTRACTORS: `Contractors`,
    TIME_WORKED: `timeWorked`,
    ADDITIONAL_EARNING: `additionalEarning`,
    NET_PAY: `netPay`,
    PAYRUN_ID: `payrunId`,
    EMPLOYEE_NAME: `employeeName`
  },
  SYNC_REVERT_JE_BOOKS_INTE: {
    PAY_PERIOD: 'payPeriod',
    TOTAL_PAYROLL_COST: 'totalCost',
    NUMBER_OF_EMPLOYEES: 'employeeCount',
    DATE_OF_JE: 'jePostedOn',
    DATE_OF_REVERSAL_JE: 'jeRevertDate'
  },
  PEOPLE_IMPORT_LOG:{
    MODULE: 'module',
    FILE_NAME: 'fileName',
    FILE_TYPE: 'fileType',
    IMPORTED_BY: 'importedBy',
    IMPORTED_ON: 'updatedAt',
    ORIGINAL_FILE: 'filePath',
    DOWNLOAD: 'updatedFilePath'
  },
  PEOPLE_DOCUMENT: {
    DOCUMENT_NAME: 'documentName',
    STATUS: 'status',
    DESCRIPTION: 'documentDescription'
  },
  PEOPLE_AUTOMATION:{
    NAME: 'name',
    CREATED_ON: 'created_on',
    SCHEDULED_ON: 'scheduled_on',
    LAST_RUN_DATE: "last_run_date",
    STATUS: "status",
    JSON_DATA: "json_data",
    WORKFLOW_CONNECTION_ID: "workflow_connection_id",
    WORKFLOW_ID: "workflow_id",
    CREATED_AT: "created_at"
  },
  PEOPLE_EXPENSE_SYNC_REVERT_JE: {
      EXPENSE_ID: 'code',
      CATEGORY: 'category',
      DATE: 'spendDate',
      APPLICANT: 'userName',
      EXPENSE_GROUP: 'groupName',
      MERCHANT: 'merchant',
      TOTAL_AMOUNT: 'totalAmount',
      DATE_OF_JE: 'dateOfJE',
      DATE_OF_REVERSAL_JE: 'dateOfReversalOfJE'
  },
  PEOPLE_EXPENSE_CLAIMS: {
      EXPENSE_ID: 'code',
      CATEGORY: 'category',
      DATE: 'spendDate',
      APPLICANT: 'userName',
      EXPENSE_GROUP: 'groupName',
      MERCHANT: 'merchant',
      TOTAL_AMOUNT: 'totalAmount',
      STATUS: 'status',
      GROUP: 'expenseGroup',
      DESCRIPTION: 'otherDetails'
  },
  PEOPLE_EXPENSE_GROUP: {
    NAME: "name",
    MEMBER_COUNT: "memberCount"
  },
  PEOPLE_EXPENSE_CATEGORY:{
    NAME: "name",
    GROUP_NAME: "groupName"
  },
  PEOPLE_EXPENSE_GROUP_USER: {
    NAME: "name",
    ROLE: "role"
  },
  PEOPLE_MULTIPLE_EXPENSE: {
    DATE: "spendDate",
    EXPENSE_ID: "id",
    MERCHANT: 'merchant',
    TOTAL_AMOUNT: 'totalAmount',
    TAX_AMOUNT:"taxAmount",
    OTHER_DETAILS: "otherDetails",
    TAX_CODE: "taxCode",
    CATEGORY_ID:"categoryId",
    ATTACHMENTS:"attachments",
    ATTACHMENTS_ID:"attachments_id",
    DESCRIPTION: "otherDetails",
    STATUS: 'status'
  },
  PEOPLE_LOCATION_LIST: {
    NAME: "name",
    TITLE: "title",
    EMAIL: "email",
    PHONE: "phone",
    ADDRESS: "address"
  },
  PEOPLE_EPF_TAX_REPORT: {
    EMPLOYEE_ID: `employeeId`,
    UAN: `uan`,
    EPF_WAGES: `epfWages`,
    EPS_WAGES	: 'epsWages',
    GROSS_WAGES: 'grossWages',
    MEMBER_NAME	: 'memberName',
    EDLI_WAGES	: 'edliWages',
    EPF_CONTRIBUTION_REMITTED	:"epfContributionRemitted",
    EPS_CONTRIBUTION_REMITTED	: "epsContributionRemitted",
    EPF_AND_EPS_DIFF_REMITTED	: 'epfEpsDiffRemitted',
    NCP_DAYS	: "ncpDays",
    REFUND_OF_ADVANCES	: "refundOfAdvance",
    PF: "pf",
    ID : `id`
  },
  PEOPLE_ESI_TAX_REPORT: {
    EMPLOYEE_ID: `employeeID`,
    EMPLOYEE_NAME: 'employeeName',
    ESI_NUMBER: "esiNumber",
    EMPLOYEE_CONTRIBUTION:"employeeContribution",
    EMPLOYER_CONTRIBUTION: "employerContribution",
    TOTAL_CONTRIBUTION:"totalContribution",
    ESI_APPLICABLE:"esiApplicable"
  },
  PEOPLE_ATTENDANCE_SETTING:{
    EMPLOYEE_NAME: "employeeName",
    LOCATION_NAME: "locations",
    COORDINATES: "coordinates",
    RADIUS: "radius",
    CLOCK_IN: "clockIn",
    CLOCK_OUT: "clockOut",
    STATUS: "status",
    IS_APPLICABLE_TO_ALL:"isApplicableToAll"
  },
  PEOPLE_LOCATION_EMPLOYEE_MAPPING:{
    NAME: "name",
    LATITUDE: "latitude",
    LONGITUDE: "longitude",
    RADIUS: "radius",
    ADDRESS: "address",
    ACTIVE: "active"
  },
  PEOPLE_ASSESSMENT_REVIEW: {
    NAME: "name",
    SELF_ASSESSMENT_STATUS: "selfAssessmentStatus",
    APPRAISER_ASSESSMENT_STATUS: "appraiserAssessmentStatus",
    ACTION: "action"
  },
  PEOPLE_GIRO:{
    PAY_PERIOD:'payPeriod',
    PAY_SCHEDULE: 'paySchedule',
    PAY_DATE: 'firstPayDate',
    NET_PAY: 'netPay',
    EMPLOYEE_GIRO: 'employeeGiro'
  },
  PEOPLE_GIRO_EMPLOYEE:{
    EMPLOYEE_NAME: 'employeeName',
    PAY_PERIOD:'payPeriod',
    NET_PAY: 'netPay',
    PAY_SCHEDULE: 'paySchedule',
    BANK: 'bank',
    GIRO_GENERATED: 'giroGenerated',
    SALARY_GIRO_GENERATED: 'salaryGiroGenerated',
    STATUTORY_GIRO_GENERATED: 'statutoryGiroGenerated',
  },
  PEOPLE_PAYMENT_LOGS: {
    DATE: "payDate",
    BATCH_ID: "batchId",
    BANK: "bank",
    PAY_PERIOD: "payPeriodFromDate",
    ACCOUNT_NUMBER: "accountNumber"
  },
  PEOPLE_IRAS_SUMMARY_REORT: {
    userId:'userId',
    employeeName: 'employeeName',
    totalBasicPay: "totalBasicPay",
    bonus: "bonus",
    directorsFee: "directorsFee",
    cpfContribution: "cpfContribution",
    donation: "donation",
    mosque: "mosque",
    other: "other",
    totalData: "totalData"

  },
  PEOPLE_AIS_SUBMISSION: {
    EMPLOYEE_ID: 'employeeId',
    EMPLOYEE_NAME: 'employeeName',
    UNIQUE_ID: 'uniqueId',
    DESIGNATION: 'designation',
    IR8A: 'ir8a',
    IR8S: 'ir8s',
    APPENDIX8A: 'appendix8a',
    APPENDIX8B: 'appendix8b'
  },
  PEOPLE_AIS_SUBMISSION_LOGS: {
      FILE_NAME: 'fileName',
      CPF_ACCOUNT: 'cpfAccount',
      YEAR: 'year',
      EMPLOYEES: 'employees',
      SUBMISSION_DATE: 'submissionDate',
      ACTION: 'submissionAction',
      RESULT: 'result',
  },
  PEOPLE_IR8S:{},
  PEOPLE_OVERTIME_LIST: {
    POLICY_NAME:'policyName',
    POLICY_DESCRIPTION: 'description',
    EMPLOYEES:"employees",
    STATUS: 'status'
  },
  PEOPLE_OVERTIME_RATE_CONFIG: {},
  PEOPLE_MANAGE_COMP_OFF:{
      NAME: "name",
      COMP_OFF_FOR: "compOffFor",
      WORKING_HOLIDAY: "workingHoliday",
      EXPIRY_MODE: "expiryMode",
      EXPIRY_AT: "expiryAt",
      DESCRIPTION: "description",
      STATUS: "status"
  },
  PEOPLE_MANAGE_COMP_OFF_REQUESTS: {
      EMPLOYEE_NAME: "employeeName",
      EMPLOYEE_ID:"employeeId",
      DAYS_LEFT:"daysLeft",
      WORKING_HOLIDAY:"workingHoliday",
      LEAVE_DATE:"leaveDate",
      DURATION:"duration",
      BALANCE:"balance",
      REQUEST_STATUS:"requestStatus",
      ATTACHMENT:"attachment",
      DESCRIPTION:"description"
  },
  PEOPLE_APPLY_COMP_OFF_REQUEST: {
      EMPLOYEE_NAME: "employeeName",
      EMPLOYEE_ID:"employeeId",
      DAYS_LEFT:"daysLeft",
      WORKING_HOLIDAY:"workingHoliday",
      LEAVE_DATE:"leaveDate",
      DURATION:"duration",
      BALANCE:"balance",
      REQUEST_STATUS:"requestStatus",
      ATTACHMENTS:"attachments",
      DESCRIPTION:"description",
      BALANCE_DAYS: "balanceDays",
      TOTAL_DAYS_AVAILABLE:'totalDaysAvailable',
      STATUS:'status'
  },
  PEOPLE_EMAIL_TEMPLATE: {
    NAME: `name`,
    DOMAIN: `domain`,
    VISITORS: `visitors`,
    STATUS: `status`,
    HTML_DATA: `html_data`,
    JSON_DATA: `json_data`,
    THUMBNAIL: `thumbnail`,
    DIRECT_LINK: `direct_link`,
    PUBLISHED: `published`,
    SEGMENT_ID: `segment_id`,
    HASH: `hash`,
    CUSTOM_DOMAIN: `custom_domain`,
  },
  PEOPLE_BASIC_EMAIL_TEMPLATE: {
    NAME: `name`,
    DEFAULT: `default`,
    STATUS: `status`,
    HTML_DATA: `html_data`,
    JSON_DATA: `json_data`
  },
  PEOPLE_FORM16: {
    FORM16_STATUS: 'form16Status',
    NAME: 'name'
  },
  PEOPLE_PERFORMANCE_GOAL: {
    PROGRESS: "progress",
    NAME:"name",
    DESCRIPTION: "description",
    START_DATE: "startDate",
    DUE_DATE: "dueDate",
    PRIORITY: "priority",
    APPLICABLE_TO: "applicableToCount",
    FILTER: "filter",
    SPECIFIC_TEAM: "specificTeam",
    SPECIFIC_DESIGNATION: "specificDesignation",
    FREQUENCY: "frequency"
  },
  PEOPLE_EXPENSE_LIMIT: {
    CATEGORIES: 'categories',
    CATEGORY_LIMIT: 'categoryLimit',
    ONE_TIME_EXPENSE_LIMIT: 'oneTimeExpenseLimit',
    EXPENSE_LIMIT_MONTHLY: 'expenseLimitMonthly',
    EXPENSE_LIMIT_YEARLY: 'expenseLimitYearly'
}
};
export const TABLE_DISPLAY_NAME = {
  [TABLES.CONTACT]: `Contacts`,
  [TABLES.CANDIDATE]: `Candidate`,
  [TABLES.SEGMENT]: `Segment List`,
  [TABLES.JOBOPENING]: `Segments / List`,
  [TABLES.DEAL]: `Deals`,
  [TABLES.CAMPAIGN]: `Email Templates`,
  [TABLES.FORM]: `Forms`,
  [TABLES.LANDING_PAGE]: `Email Templates`,
  [TABLES.AUTOMATION]: `Automation`,
  [TABLES.FUNNEL]: `Funnels`,
  [TABLES.JOB_PIPELINE]: `Pipelines`,
  [TABLES.JOB_STAGE]: `Stage`,
  [TABLES.JOB_FORMS]: `Forms`,
  [PRODUCTS.PAYROLL]: `Payroll`,
  [PRODUCTS.ELEAVE]: `Eleave`,
  [PRODUCTS.EXPENSE]: `Expense`,
  [PRODUCTS.EXPENSE_TREND]: `Expense Claims Trend`,
  [TABLES.PAYROLL]: `Payroll`,
  [TABLES.ATTENDANCE]: `Attendance`,
  [TABLES.PAYROLL]: `Payruns`,
  [TABLES.ADD_PAYROLL]: `Payroll`,
  [TABLES.PAYROLL_PROCESS]: `Payrun Details`,
  [TABLES.PAYMENT_SUMMARY]: `Payment Summary`,
  [TABLES.EMPLOYEE_LIST]: `Employees`,
  [TABLES.PEOPLE_COMPONENT]: 'Component',
  [TABLES.PAY_SCHEDULE]:'Pay Schedules',
  [TABLES.PEOPLE_EMPLOYEE_TAX_DECLARATION]: "Employee",
  [TABLES.CUSTOME_FIELD_LIST]:'Custom Fields',
  [TABLES.JOB_FORMS]:'Job Forms',
  [TABLES.BENEFIT_LIST]: 'Benefits',
  [TABLES.CONTRACTOR_LIST]: 'Contractors',
  [TABLES.PAYSTUB_LIST]: 'Paystubs',
  [TABLES.CONTRACTOR_PAYROLL]: 'Contractor Payrun',
  [TABLES.COMPONENT_GROUP_LIST]: 'Component Template',
  [TABLES.IMPORT_LOG]: 'Import Log',
  [TABLES.PEOPLE_DOCUMENT]: `Documents`,
  [TABLES.PEOPLE_AUTOMATION]: `Automation`,
  [TABLES.PEOPLE_EXPENSE_CLAIMS]: "Expense Claims",
  [TABLES.PEOPLE_EXPENSE_GROUP]: "Expenses Groups",
  [TABLES.PEOPLE_EXPENSE_CATEGORY]: "Categories",
  [TABLES.PEOPLE_EXPENSE_GROUP_USER]: "Expense Group User",
  [TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS]: "Claims to Review",
  [TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_CATEGORY]: "My Categories Breakdown",
  [TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_GROUP]: "Group Claims Breakdown",
  [TABLES.PEOPLE_EXPENSE_MY_CLAIMS]: "My Claims",
  [TABLES.PEOPLE_EXPENSE_APPROVED_CLAIMS]: "Claims to Reimburse",
  [TABLES.PEOPLE_LOCATION_LIST] : "My Locations",
  [TABLES.PEOPLE_ATTENDANCE_SETTING]: "Attendance Setting",
  [TABLES.PEOPLE_ASSESSMENT_REVIEW]: "Reviews",
  [TABLES.PEOPLE_GIRO]: 'Pay',
  [TABLES.PEOPLE_GIRO_EMPLOYEE]:'Giro Employee',
  [TABLES.PEOPLE_PAYMENT_LOGS]: "Payment Logs",
  [TABLES.PEOPLE_SHIFTS]: "Shifts",
  [TABLES.PEOPLE_SHIFT_MEMBERS]: "Shift Members",
  [TABLES.PEOPLE_ASSIGN_MEMBERS]: "Assign Members",
  [TABLES.PEOPLE_OVERTIME_LIST]: "Overtime Policy",
  [TABLES.PEOPLE_OVERTIME_RATE_CONFIG]: "Overtime Payroll Multiplier",
  [TABLES.PEOPLE_MANAGE_COMP_OFF]: "Manage Comp Offs",
  [TABLES.PEOPLE_MANAGE_COMP_OFF_REQUESTS]: "Manage Comp Off Requests",
  [TABLES.PEOPLE_APPLY_COMP_OFF_REQUEST] : "My Comp off",
  [TABLES.PEOPLE_EMAIL_TEMPLATE]: `Email Templates`,
  [TABLES.PEOPLE_AUDIT_LOGS]: "Audit Logs",
  [TABLES.TEAM_ATTENDANCE]:"Team Attendance",
  [TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE]: "Email templates",
  [TABLES.PEOPLE_DASHBAORD_TEAM_ATTENDANCE]: "Team Attendance",
  [TABLES.PEOPLE_TIMESHEET_REPORT]: "Timesheet Report",
  [TABLES.PEOPLE_TIMESHEET_REPORT_GROUP]: "Timesheet Report Group",
  [TABLES.PEOPLE_FORM16]: " ",
  [TABLES.PEOPLE_SALARY_HISTORY]: "Employee Update History",
  [TABLES.PEOPLE_PERFORMANCE_GOAL]: "Goals",
  [TABLES.PEOPLE_APPRAISAL_CYCLES]: "Appraisal Cycles",
  [TABLES.PEOPLE_EXPENSE_LIMIT]: "Expense Limit Policy",
  [TABLES.PEOPLE_PROJECT]: "Projects",
  [TABLES.PEOPLE_TASK]: "Tasks",
  [TABLES.PEOPLE_TIMESHEET_ENTRY]: "Timesheet",
  [TABLES.PEOPLE_COMMISSION_REPORT]: "",
  [TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE]: "",
  [TABLES.POLICY_AND_RESOURCES]: "Policy & Resources"
};
export class TableManger {
  static tableMap = new Map();
  static populateViewMap(data) {

    data.forEach((item) => {
      this.tableMap.set(item["name"], TableDataParser.parseTableData(item));
    });
    TableDataParser.checkAndReplaceSegment();
  }
  static setTableColumns(columnData, tableName: string) {
    this.tableMap.set(tableName, {
      ...this.tableMap.get(tableName),
      ...TableDataParser.parseTableData(columnData),
    });
    TableDataParser.checkAndReplaceSegment();
  }
  static updateColumn(columnCode, tableName, columnData) {
    let columnsIndex = this.tableMap
      .get(tableName)
      .columns.findIndex((column) => column.columnCode === columnCode);
    let columns = this.tableMap.get(tableName).columns;
    columns.splice(columnsIndex, 1, columnData);
    this.tableMap.set(tableName, { ...this.tableMap.get(tableName), columns });
  }
  static getTableId(tableName: string): string {
    return this.tableMap.get(tableName)?.id;
  }
  static getTableName(tableName: string): string {
    return this.tableMap.get(tableName).name;
  }
  static getTableColumns(tableName: string): IColumn[] {

    return this.tableMap.get(tableName)?.columns;
  }
  static getTableVisibleColumns(tableName: string): IColumn[] {
    return this.getTableColumns(tableName)?.filter((column) => !column.hidden);
  }
  static getTableImportColumns(
    tableName: string,
    excludedColumns?: Array<string>
  ): IColumn[] {
    return this.getTableColumns(tableName).filter((column) => {
      const isExcluded =
        excludedColumns && excludedColumns.includes(column.columnCode);
      const isEditable = column.uiVisible && column.editable;

      return !isExcluded && isEditable;
    });
  }
  static getColumnId(tableName: string, columnCode: string): string {
    let column = this.getColumn(tableName, columnCode);
    return column ? column.id : undefined;
  }
  static getColumn(tableName: string, columnCode: string): IColumn {
    return this.getTableColumns(tableName)?.find(
      (column) => (column.columnCode ? column.columnCode : column.name) === columnCode
    );
  }
  static getColumnById(tableName: string, columnCode: string): IColumn {
    return this.getTableColumns(tableName)?.find(
      (column) => (column.id ? column.id : column.name) === columnCode
    );
  }
  static getFilterObject(data): ITableFilter {
    let filterObject: ITableFilter = {
      logicalOperator: "and",
      conditions: [],
    };
    data.forEach((item) =>
      filterObject.conditions.push(this.getFilterSubCondition(item))
    );
    return filterObject;
  }
  static getFilterSubCondition(item): IFilterCondition {
    return {
      colId: item.key,
      value: item.value,
      opr: item.condition,
    };
  }
  static isSelectField(column) {
    return column.type === INPUT_TYPE.SELECT || column.type === INPUT_TYPE.MULTI_SELECT || column.type === "ref";
  }
  static getTableFilteredColumns(
    tableName: string,
    condition?: Function,
    filterEditable?: Boolean
  ): IColumn[] {
    return this.getTableColumns(tableName).filter((column) => {
      const isIncluded = condition(column);
      const isEditable = column.uiVisible && column.editable;

      return filterEditable ? isIncluded && isEditable : isIncluded;
    });
  }

  static getAllTableFilteredColumns(
    tableName: string,
    condition?: Function,
    filterEditable?: Boolean
  ): IColumn[] {
    return this.getTableColumns(tableName).filter((column) => {
      const isIncluded = condition(column);
      const isEditable = column.uiVisible;

      return filterEditable ? isIncluded && isEditable : isIncluded;
    });
  }
}
